/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { Table, TableBody, TableCell, TableContainer, Checkbox, TableHead, TableRow, Button, TextField, Box, FormControlLabel, FormControl, Radio, FormLabel, RadioGroup, Typography } from "@mui/material";
import { Row, Col, Space, Image } from "antd";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { NavLink } from "react-router-dom";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import actions from "../../redux/actions";
import { toast } from 'react-toastify';
import { useEventListener } from "../../../../../helpers/useEventListener";
import { idNamingConversion } from "../../../../../helpers/utilities";


export const CustomForm = (props) => {
    const { createDetails, createError,
        deleteDetails, deleteError,
        editDetails, editError, createLoader, editLoader } = useSelector(state => state.crudReducer);
    const { posSetupUsers, posSetupUsersloader } = useSelector(state => state.salesSetupReducer);
    const { visible, posId, view, form, error, classes, locationDetails,
        customerDetails, changeHandler, customObject, mopDetails, getTeamList, parameterDetails,
        handleClose, clsx, createPos, teamDetails, handleAddMore, handleView, dispatch, handleDefaultUser } = props;
    const [pointOfSalesUsersId, setPointOfSalesUsersId] = useState([]);
    const [isUserNew, setIsUserNew] = useState(false);
    const [posUserCreate, setPosUserCreate] = useState('');
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const prevDeleteDetails = usePrevious(deleteDetails);
    const prevDeleteError = usePrevious(deleteError);
    const [deletePosId, setDeletePosId] = useState('')

    const handleUser = (id) => {
        let details = {
            'posId': form?.id,
            'userId': id,
            'isDefaultUser': false
        };
        dispatch({
            type: crudActions.CREATE_DETAILS_START,
            url: 'point-of-sale-users',
            id: posId,
            title: 'Point of Sale Users',
            details: details
        });
        setPosUserCreate(true);
        setIsUserNew(false);
    }

    const deletePosList = (data) => {
        setDeletePosId(data.posId);
        dispatch({
            type: crudActions.DELETE_DETAILS_START,
            url: 'point-of-sale-users',
            title: 'Point of Sale Users',
            id: data.id
        });
        setPointOfSalesUsersId(prevState => {
            return prevState.filter((value, i) => value !== data.userId)
        })
    }

    useEffect(() => {
        if (posSetupUsers?.length > 0) {
            setIsUserNew(false);
            let data = [];
            posSetupUsers.map((el) => {
                data.push(el.userId);
            });
            setPointOfSalesUsersId(data);
        }
    }, [posSetupUsers]);

    const handleClick = (data) => {
        let user = customObject(getTeamList, data.userId);
        let details = { 'defaultUserId': data.userId };
        if (user) {
            details['defaultUserName'] = user.name;
        }
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: 'point-of-sales',
            id: data?.posId,
            title: 'Point of Sales',
            details: details
        });
        setPosUserCreate(true);
        handleDefaultUser(data.userId);
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: 'point-of-sale-users',
            id: data?.id,
            title: 'Point of Sales',
            details: { 'isDefaultUser': !data.isDefaultUser }
        });
    }

    const userDispatch = (posId) => {
        dispatch({
            type: actions.POS_SETUP_USERS_START,
            url: 'point-of-sale-users',
            filter: {
                where: { "posId": posId },
            }
        });
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            if (posUserCreate) {
                userDispatch(form?.id);
                setPosUserCreate(false);
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (prevDeleteDetails !== undefined && deleteDetails && prevDeleteDetails !== deleteDetails) {
            userDispatch(form?.id);
            setDeletePosId('');
        } else if (prevDeleteError !== undefined && deleteError && prevDeleteError !== deleteError) {
            let message = deleteError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [deleteDetails, deleteError]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            if (posUserCreate) {
                userDispatch(form?.id);
                setPosUserCreate(false);
            }
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [editDetails, editError]);


    const handleKeyDown = (e) => {
        if (visible && e.keyCode === 13) {
            e.preventDefault();
            createPos(e);
        }
    }

    useEventListener("keydown", handleKeyDown);

    return (
        <PrimaryDrawer
            anchor={'right'}
            open={visible}
            variant={'temporary'}
            handleClose={() => handleClose()}
            title={`${posId ? `${view ? 'View' : 'Edit'}` : 'New'} POS`}
            className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
            width={"495px"}
            component={
                <Box
                    className={clsx(classes.customForm, classes.removeUnderline, deletePosId)}
                    component="form"
                    autoComplete="off"
                    onSubmit={(e) => createPos(e)}>
                    <div className={classes.customFormFlexRemoveOverflow}>
                        <div className={classes.customFormFlex}>
                            <Row type="flex" gutter={40}>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>POS Number</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.posNumber}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label={["POS Number ", <span key={"POS Number"} className={classes.colorRedRequired}> *</span>]}
                                                name={"posNumber"}
                                                value={form.posNumber}
                                                variant={'standard'}
                                                error={error?.posNumber && true}
                                                helperText={error?.posNumber}
                                                fullWidth
                                                id={idNamingConversion('POS Number', 'pointOfSale', 'TextField')}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Default Customer</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.defaultCustomerName || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Default Customer ", <span key={"Default Customer"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'serialNo', 'name': 'Customer ID' },
                                                { 'key': 'name', 'name': 'Name' }]}
                                                id={idNamingConversion('POS Number', 'pointOfSale', 'DropDown')}
                                                details={customerDetails}
                                                parentValue={customObject(customerDetails, form?.defaultCustomerId)}
                                                onChange={(data) => changeHandler(data.id, 'defaultCustomerId')}
                                                parentError={error?.defaultCustomerId}
                                                position={"bottom"}
                                            />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Description</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.description || '---'}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label={["Description"]}
                                                name={"description"}
                                                value={form?.description}
                                                variant={'standard'}
                                                className={classes.margin20t}
                                                fullWidth
                                                id={idNamingConversion('Description', 'pointOfSale', 'TextField')}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Default User</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.defaultUserName || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Default User ", <span key={"Default User"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                details={teamDetails}
                                                id={idNamingConversion('Default User', 'pointOfSale', 'DropDown')}
                                                parentValue={customObject(teamDetails, form?.defaultUserId)}
                                                onChange={(data) => changeHandler(data.id, 'defaultUserId')}
                                                parentError={error?.defaultUserId}
                                                position={"bottom"}
                                                customClasses={clsx(classes.margin20t, { [classes.disabled]: posId })}
                                            />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Default Method of Payment (MOP)</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.defaultMopName || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Default Method of Payment (MOP) ", <span key={"Default Method of Payment (MOP)"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'method', 'name': 'Name' }]}
                                                details={parameterDetails?.mopIds && parameterDetails?.mopIds?.length > 0 ? mopDetails.filter(item => parameterDetails?.mopIds.includes(item.id)) : mopDetails}
                                                id={idNamingConversion('Default Method of Payment', 'pointOfSale', 'DropDown')}
                                                parentValue={customObject(mopDetails, form?.defaultMopId)}
                                                onChange={(data) => changeHandler(data.id, 'defaultMopId')}
                                                parentError={error?.defaultMopId}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                            />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Receipt Template</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.receiptTemplate || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Receipt Template ", <span key={"Receipt Template"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                id={idNamingConversion('Receipt Template', 'pointOfSale', 'DropDown')}
                                                details={[
                                                    { id: "format1", name: "Format 1" },
                                                    { id: "format2", name: "Format 2" },
                                                    // { id: "Small terminal :57mm x 38mm", name: "Small terminal : 57mm x 38mm" },
                                                    // { id: "Thermal :80mm x 80mm", name: "Thermal : 80mm x 80mm" },
                                                    // { id: "Thermal :80mm x 70mm", name: "Thermal : 80mm x 70mm" },
                                                    // { id: "Thermal :80mm x 60mm", name: "Thermal : 80mm x 60mm" },
                                                    //  { id: "A4", name: "A4" },
                                                ]}
                                                parentValue={customObject([
                                                    { id: "format1", name: "Format 1" },
                                                    { id: "format2", name: "Format 2" },
                                                    // { id: "Small terminal : 57mm x 50mm", name: "Small terminal : 57mm x 50mm" },
                                                    // { id: "Small terminal :57mm x 40mm", name: "Small terminal : 57mm x 40mm" },
                                                    // { id: "Small terminal :57mm x 38mm", name: "Small terminal : 57mm x 38mm" },
                                                    // { id: "Thermal :80mm x 80mm", name: "Thermal : 80mm x 80mm" },
                                                    // { id: "Thermal :80mm x 70mm", name: "Thermal : 80mm x 70mm" },
                                                    // { id: "Thermal :80mm x 60mm", name: "Thermal : 80mm x 60mm" },
                                                    //{ id: "A4", name: "A4" },
                                                ], form?.receiptTemplate)}
                                                onChange={(data) => changeHandler(data.id, 'receiptTemplate')}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                parentError={error?.receiptTemplate}
                                            />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Location</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.location?.name || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Location ", <span key={"Location"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                id={idNamingConversion('Location', 'pointOfSale', 'DropDown')}
                                                details={locationDetails}
                                                parentValue={customObject(locationDetails, form?.locationId)}
                                                onChange={(data) => changeHandler(data.id, 'locationId')}
                                                parentError={error?.locationId}
                                                customClasses={classes.margin20t}
                                                position={"bottom"}
                                            />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Thermal Printer Image</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.thermalPrinterImage || '---'}</Typography>
                                            </> :
                                            <FormControl
                                                tabIndex={-1}
                                                className={clsx(classes.margin20t, classes.dropDownPointer, classes.customRadioButton, classes.customIdentityRadioButton)}
                                                variant={'standard'}
                                                fullWidth>
                                                <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Thermal Printer Image</FormLabel>
                                                <RadioGroup row
                                                    defaultValue={""}
                                                    aria-labelledby="demo-customized-radios"
                                                    name="thermalPrinterImage"
                                                    value={form?.thermalPrinterImage || ""}
                                                    onChange={(e) => changeHandler(e.target.value, 'thermalPrinterImage')}>
                                                    <FormControlLabel value={""} control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="None" />
                                                    <FormControlLabel value={"logo"} control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="Logo" />
                                                    <FormControlLabel value={"qr"} control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="QR Code" />
                                                </RadioGroup>
                                            </FormControl>
                                    }
                                </Col>
                                {/* <Col span={24}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Device Identifier</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.deviceIdentifier || '---'}</Typography>
                                            </> : <TextField autoComplete='one-time-code'
                                                label={["Device Identifier ", <span key={"Device Identifier"} className={classes.colorRedRequired}> *</span>]}
                                                fullWidth
                                                name={"deviceIdentifier"}
                                                error={error?.deviceIdentifier && true}
                                                helperText={error?.deviceIdentifier}
                                                value={form?.deviceIdentifier || ''}
                                                variant={'standard'}
                                                className={clsx(classes.margin20t)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />

                                    }
                                </Col> */}
                            </Row>
                            <></>
                        </div>
                        {
                            posId && <div>
                                <div className={clsx(classes.PrimaryCard2)}>POS Users</div>
                                <Row className={clsx(classes.PrimaryCard2RowAlign)}>
                                    <Col className={classes.textAlignRight}>
                                        {
                                            !view &&
                                            <NavLink
                                                to={'#'}
                                                id={idNamingConversion('Add Users', 'pointOfSale', 'Link')}
                                                className={clsx(classes.customLink)}
                                                onClick={(e) => setIsUserNew(true)}>
                                                <Image
                                                    src={AddIcon}
                                                    preview={false}
                                                    className={clsx(classes.antImage)}
                                                /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Users</span>
                                            </NavLink>
                                        }
                                    </Col>
                                </Row>
                                <TableContainer className={classes.partyGstFormTable}>
                                    <Table>
                                        <TableHead>
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell sx={{ width: 300 }}>{'User Name'}</TableCell>
                                                <TableCell className={clsx(classes.textAlignCenter)}>{'Default'}</TableCell>
                                                <TableCell style={{ textAlign: "right" }}>{'Actions'}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                posSetupUsersloader ? <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className={classes.textAlignCenter} colSpan={7}><div className={classes.loadMoreCircle}></div></TableCell>
                                                </TableRow> :
                                                    <>
                                                        {
                                                            posSetupUsers?.length > 0 ? posSetupUsers?.map((data, i) => (
                                                                <TableRow key={i}>
                                                                    <TableCell>{data?.user?.name || '---'}</TableCell>
                                                                    <TableCell className={clsx(classes.textAlignCenter)}><Checkbox className={clsx(classes.posDefaultCheckbox, { [classes.disabled]: data.isDefaultUser || view })} checked={data.isDefaultUser}
                                                                        onChange={(e) => handleClick(data)} /></TableCell>
                                                                    <TableCell className={classes.textAlignRight}>
                                                                        <Image
                                                                            src={DeleteIcon}
                                                                            preview={false}
                                                                            className={clsx(classes.cursor, { [classes.disabled]: data.isDefaultUser || view })}
                                                                            onClick={(e) => data.isDefaultUser || view ? '' : deletePosList(data)}
                                                                        />
                                                                    </TableCell>
                                                                </TableRow>
                                                            )) : <TableRow>
                                                                <TableCell style={{ textAlign: "center" }} colSpan={3} className={classes.textAlignRight}>There is no user added</TableCell>
                                                            </TableRow>
                                                        }
                                                    </>
                                            }
                                            {
                                                isUserNew && (
                                                    <TableRow>
                                                        <TableCell>
                                                            <AutoCompleteComponent
                                                                name={["Select"]}
                                                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                                details={getTeamList?.filter((el) => { return pointOfSalesUsersId.every(e => parseInt(e) !== parseInt(el.id)) })}
                                                                parentValue={[]}
                                                                id={idNamingConversion('User', 'pointOfSale', 'DropDown')}
                                                                onChange={(data) => handleUser(data.id)}
                                                                //parentError={error?.defaultCustomerId}
                                                                position={"top"}
                                                            />
                                                        </TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell className={classes.textAlignRight}>
                                                            <Space>
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                    className={classes.cursor}
                                                                    onClick={(e) => setIsUserNew(false)}
                                                                />
                                                            </Space>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>

                        }

                    </div>
                    <div className={clsx(classes.btnParent)}>
                        {
                            !view ?
                                <Space direction="horizontal" align="center" size={[10, 10]}>
                                    <Button
                                        key="save"
                                        color="primary"
                                        variant="contained"
                                        type={'submit'}
                                        id={idNamingConversion('Save', 'pointOfSale', 'Button')}
                                        className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                        {
                                            posId ? 'Update & Close' : 'Save & Close'
                                        }
                                    </Button>
                                    {
                                        !posId &&
                                        <Button
                                            key="save"
                                            color="primary"
                                            variant="contained"
                                            id={idNamingConversion('Add More', 'pointOfSale', 'Button')}
                                            onClick={(e) => handleAddMore(e)}
                                            className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                        >Add More</Button>
                                    }
                                </Space> : <Space direction="horizontal" align="center" size={[10, 10]}>
                                    <NavLink to={'#'} className={clsx(classes.AddMoreBtn)} onClick={() => { setIsUserNew(true); handleView(false) }}>Add User</NavLink>
                                    <NavLink to={'#'} className={clsx(classes.AddMoreBtn)} onClick={() => handleView(false)}>Edit</NavLink>
                                </Space>
                        }
                    </div>
                </Box>
            }
        />
    )
}